const LYCEE_CLASSES = ["2nde", "1ère", "Tle"]

export const getDefaultMaterialDuration = (cls) =>
    LYCEE_CLASSES.includes(cls) ? "10" : "5"

export const MATERIAL_DURATION_OPTIONS = [
    { label: "5 min", value: "5" },
    { label: "10 min", value: "10" },
    { label: "15 min", value: "15" },
]
